import React from "react";
import chefImage from "../../assets/Chef.png";
import appImage from "../../assets/icon.png";
import foods from "../../assets/foods.png";
import char from "../../assets/char.png";
import cooking from "../../assets/cooking.png";

const AboutUs = () => {
  const styles = `
    body {
      background-color: #fff;
      font-family: 'Poppins', Arial, sans-serif;
      margin: 0;
      padding: 0;
    }

    .about-container {
      padding: 40px 15px;
      max-width: 1200px;
      margin: 0 auto;
      color: #333;
    }

    .section-tag {
      color: #f97316;
      font-size: 0.9rem;
      font-weight: 600;
      text-transform: uppercase;
      margin-bottom: 10px;
      text-align: center;
    }

    .about-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 40px;
      margin-bottom: 60px;
      flex-wrap: wrap;
    }

    .about-section.reverse {
      flex-direction: row-reverse;
    }

    .about-content {
      flex: 1;
      min-width: 300px;
    }

    .about-content h1, 
    .about-content h2 {
      font-size: 2rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 15px;
    }

    .about-content span {
      color: #f97316;
    }

    .about-content p {
      color: #555;
      line-height: 1.8;
      margin-bottom: 20px;
      font-size: 1rem;
    }

    .about-image {
      flex: 1;
      text-align: center;
    }

    .about-image img {
      width: 100%;
      max-width: 420px;
      border-radius: 12px;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }

    /* Features List */
    .features-list {
      margin-top: 15px;
      padding-left: 20px;
    }

    .features-list li {
      margin-bottom: 12px;
      font-size: 1rem;
      color: #444;
      line-height: 1.6;
    }

    .features-list li strong {
      color: #1a1a1a;
    }

    /* CTA */
    .cta-section {
      display: flex;
      justify-content: space-around;
      align-items: center;
      background-color: #fff5f0;
      padding: 40px 25px;
      border-radius: 12px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
      flex-wrap: wrap;
      gap: 30px;
      margin-top: 60px;
    }

    .cta-content {
      flex: 1;
      min-width: 250px;
      text-align: center;
    }

    .cta-content h2 {
      font-size: 1.8rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 15px;
    }

    .cta-content span {
      color: #f97316;
    }

    .cta-content p {
      color: #666;
      margin-bottom: 20px;
      font-size: 1rem;
    }

    .cta-button {
      background-color: #f97316;
      color: #fff;
      padding: 12px 25px;
      font-size: 1rem;
      border: none;
      border-radius: 50px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.3s ease;
      text-decoration: none;
      display: inline-block;
    }

    .cta-button:hover {
      background-color: #ea580c;
      transform: translateY(-2px);
    }

    .cta-image img {
      width: 1000px; 
      height: auto; 
}
    .cta-image img {
      max-width: 200px;
    }


    /* ===================
       Mobile Responsive
       =================== */
    @media (max-width: 768px) {
      .about-section {
        flex-direction: column;
        text-align: center;
        gap: 20px;
        margin-bottom: 40px;
      }

      .about-section.reverse {
        flex-direction: column;
      }

      .about-content h1, 
      .about-content h2 {
        font-size: 1.5rem;
      }

      .about-content p {
        font-size: 0.95rem;
        line-height: 1.6;
      }

      .features-list {
        padding-left: 0;
        text-align: left;
      }

      .cta-section {
        flex-direction: column;
        text-align: center;
        padding: 30px 20px;
      }

      .cta-content h2 {
        font-size: 1.4rem;
      }

      .cta-button {
        width: 100%;
      }

      .cta-image {
        display: none;
      }
    }
  `;

  return (
    <div className="about-container">
      <style>{styles}</style>

      {/* About Us */}
      <div className="about-section">
        <div className="about-content">
          <p className="section-tag">About Us</p>
          <h4 style={{marginTop:"2rem"}}>About us</h4>
          <h1>
            Story of <span>TIFFO Foods</span>
          </h1>
          <p>
            TIFFO Foods is a modern cloud kitchen based in{" "}
            <strong>Charminar, Hyderabad</strong>, built with a passion for
            delivering <strong>fresh, hygienic, and affordable meals</strong> to
            students, working professionals, and families.
          </p>
          <p>
            We believe that food is more than just a meal; it is an experience
            of comfort, trust, and care. At TIFFO, every dish is thoughtfully
            prepared to bring together the flavors of tradition with the
            convenience of modern-day food delivery. With starting prices as low
            as <strong>₹79</strong>, our meals are designed to be
            pocket-friendly without compromising on quality.
          </p>
        </div>
        <div className="about-image">
          <img src={char} alt="Delicious TIFFO Foods dishes" />
        </div>
      </div>

      {/* Our Story */}
      <div className="about-section reverse">
        <div className="about-content">
          <p className="section-tag">Our Story</p>
          <p>
            Founded with the vision of providing wholesome meals in the heart of
            Hyderabad, TIFFO Foods was born out of the desire to serve people
            who miss the warmth of homemade food. Whether it's students living
            away from family, professionals on a busy schedule, or families
            looking for affordable tiffin options, our service is built around
            the idea of serving <strong>“ghar jaisa khana”</strong> that feels
            both familiar and fulfilling.
          </p>
        </div>
        <div className="about-image">
          <img src={cooking} alt="Chef cooking TIFFO Foods" />
        </div>
      </div>

      {/* What Makes Us Different */}
      <div className="about-section">
        <div className="about-content">
          <p className="section-tag">What Makes Us Different</p>
          <ul className="features-list">
            <li>
              <strong style={{ color: "#FF5600" }}>Affordable & Accessible:</strong>{" "}
              Quality meals starting at just ₹79.
            </li>
            <li>
              <strong style={{ color: "#FF5600" }}>Homely Taste:</strong>{" "}
              Recipes prepared with a balance of taste and nutrition.
            </li>
            <li>
              <strong style={{ color: "#FF5600" }}>Fresh & Hygienic:</strong>{" "}
              Food cooked daily in a clean, carefully maintained kitchen.
            </li>
            <li>
              <strong style={{ color: "#FF5600" }}>Customer-Centric:</strong>{" "}
              Easy ordering through UPI/QR payments with quick service.
            </li>
            <li>
              <strong style={{ color: "#FF5600" }}>Focused Service:</strong>{" "}
              Special care for students and professionals with tailored tiffin
              solutions.
            </li>
          </ul>
        </div>
        <div className="about-image">
          <img src={foods} alt="Healthy TIFFO Foods meals" />
        </div>
      </div>

      {/* Our Commitment */}
      <div className="about-section reverse">
        <div className="about-content">
          <p className="section-tag">Our Commitment</p>
          <p>
            At TIFFO Foods, we prioritize freshness, hygiene, and consistency.
            Each box is packed with care to ensure every customer receives food
            that is not only tasty but also healthy and fulfilling. Our fixed
            tiffin layouts and customizable options make it simple for customers
            to enjoy a variety of meals while knowing exactly what they can
            expect.
          </p>
        </div>
        <div className="about-image">
          <img src={chefImage} alt="TIFFO meal box" />
        </div>
      </div>

      {/* Our Vision */}
      <div className="about-section">
        <div className="about-content">
          <p className="section-tag">Our Vision</p>
          <p>
            As we continue to grow, our goal is to expand services across more
            areas of Hyderabad while keeping our promise of affordability and
            authenticity. TIFFO Foods aims to be recognized not just as a food
            service, but as a trusted companion for everyday meals – combining{" "}
            <strong>taste, convenience, and value</strong>.
          </p>
          <p>
            TIFFO Foods is more than just food delivery. It is about creating
            connections through food – serving warmth, reliability, and
            happiness in every box.
          </p>
        </div>
        <div className="about-image">
          <img src={appImage} alt="TIFFO Foods app" />
        </div>
      </div>

      {/* CTA */}
      <div className="cta-section">
        <div className="cta-content">
          <h2>
            Get Started With <span>TIFFO Foods</span> Today!
          </h2>
          <p>
            Order now and enjoy homely meals delivered to your doorstep in
            Hyderabad at just ₹79.
          </p>
          <a href="/menu" className="cta-button">
            Order Now
          </a>
        </div>
        <div className="cta-image">
          <img src={appImage} alt="TIFFO Foods App" />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
